import { Body } from "./Body";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Root } from "./Root";

export const Panel = Object.assign(Root, {
  Header,
  Body,
  Footer,
});
